import { featureReducers } from '@redux/feature/reducers'
import { shellReducers } from '@redux/shell/reducers'
import { configureStore } from '@reduxjs/toolkit'

// shellReducers: app shell state needed on every page (session, profile, permissions, intl, etc.)
// featureReducers: feature-module state; candidates for dynamic registration in Phase 6
export const initializeStore = (preloadedState = {}) =>
  configureStore({
    reducer: {
      ...shellReducers,
      ...featureReducers,
    },
    preloadedState,
    devTools: true,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredPaths: ['activeState.learningPath'],
          ignoredActions: ['activeState/activeLearningPathUpdated'],
        },
      }),
  })
